import { useQuery } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';

export interface IUserDetailsTabsStats {
    photosCount: number;
    subaccountsCount: number;
    transactionsCount: number;
    paymentsCount: number;
}

type TParams = {
    userId: string;
};

export const useRequestGetUserDetailsTabsStats = (params?: TParams, run = true) => {
    const { isFetching: isLoadingStats, data: stats, error } = useQuery({
        queryKey: [routes.api.users.base, 'tabs-stats', params?.userId, run],
        queryFn: () =>
            !run || !params?.userId
                ? Promise.resolve(null)
                : apiClient
                    .get<IUserDetailsTabsStats>(routes.api.users.detailsTabsStats(params.userId))
                    .then(handleApiResponse),
        enabled: run && !!params?.userId,
        staleTime: 1000 * 60 * 5, // 5 minutes
    });

    return {
        isLoadingStats,
        stats,
        error,
    };
};
